<div class="log-detail-form">
  <div *ngFor="let campo of campos" class="form-section">
    <label class="campo-label">{{ campo.campo }}</label>

    <div class="input-row">
      <div class="form-group">
        <label>Valor Original</label>
        <input type="text" class="form-control"
               [value]="formatarDataSeForData(campo.valorOriginal)" readonly />
      </div>

      <div class="form-group">
        <label>Novo Valor</label>
        <input type="text" class="form-control"
               [value]="formatarDataSeForData(campo.novoValor)" readonly />
      </div>
    </div>
  </div>
</div>
